import { createContext } from 'react';
import type { DataPoint, MetricDefinition } from '../types/dashboard';

export interface DashboardDataContextValue {
  /** Maps datasetId references in ChartConfig to actual data rows */
  datasets: Record<string, DataPoint[]>;
  /** Metrics catalog for chart card statistics (e.g. R², RMSE) */
  metrics: MetricDefinition[];
  /** Helper: get dataset by id, returns [] if not found */
  getDataset: (id: string) => DataPoint[];
  /** Helper: get field names from a dataset (for WidgetEditor dropdowns) */
  getDatasetFields: (id: string) => string[];
  /** Helper: list available dataset ids (for WidgetEditor picker) */
  datasetIds: string[];
}

export const DashboardDataContext = createContext<DashboardDataContextValue | null>(null);
